export const links = [
  { text: "Что это", url: "whatIs" },
  { text: "Как работает", url: "howItWork" },
  // { text: "Forecast", url: "forecust" },
  { text: "DAO", url: "dao" },
  // { text: "Дорожная карта", url: "roadMap" },
  // { text: "Токеномика", url: "tokenomikcs" },
];
